import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64fefa51"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }

import {computed, onBeforeMount, reactive, ref} from "vue";
import {type_consumables, type_fixed, type_intangible} from "@/views/ViewsComponents/officeAssets/OfficeAssetUtils";
import FixedAssetStatisticalInfo from "@/views/ViewsComponents/officeAssets/FixedAssetStatisticalInfo.vue";
import Api from "@/http/modules";
import IntangibleStatisticalInfo from "@/views/ViewsComponents/officeAssets/IntangibleStatisticalInfo.vue";
import ConsumablesStatisticalInfo from "@/views/ViewsComponents/officeAssets/ConsumablesStatisticalInfo.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  // 获取所有团队
  'GET/company': companyApi,
  'GET/organizations': organizationsApi,
  'GET/office/asset/category/{type}/valid_list': validCategoriesApi,
  'GET/users': usersListApi,
  //资产查询
  "POST/office/asset/search": assetSearchApi,
  //资产详情
  "GET/office/asset/{id}/detail": assetDetailApi,
  //资产生命周期
  "GET/office/asset/{id}/life_cycle": assetLifeCycleApi,
  "POST/office/asset/fixed_asset_count": fixedAssetCountApi,
  "POST/office/asset/export_asset": exportApi,
} = Api
const activeTable = ref(type_fixed)

const options = reactive<{ orgs: any[],companies: any[], categories: any[] }>({
  orgs: [],
  companies: [],
  categories: [],
})
let fixedCategories = computed(() => {
  return options.categories.filter(i => i.type == type_fixed)
})
let consumablesCategories = computed(() => {
  return options.categories.filter(i => i.type == type_consumables)
})


onBeforeMount(() => {
  if (options.companies.length < 1) {
    companyApi().then((r: any) => {
      options.companies = r;
    })
  }
  if (options.orgs.length < 1) {
    organizationsApi().then((r: any) => {
      options.orgs = r;
    })
  }
  if (options.categories.length < 1) {
    validCategoriesApi({type: "all"}).then((r: any) => {
      options.categories = r
    })
  }
})


return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tabs, {
      class: "tabs type-tabs",
      modelValue: activeTable.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTable).value = $event)),
      type: "border-card"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "固定资产查询",
          name: _unref(type_fixed)
        }, {
          default: _withCtx(() => [
            _createVNode(FixedAssetStatisticalInfo, {
              "export-api": _unref(exportApi),
              "fixed-asset-count-api": _unref(fixedAssetCountApi),
              "asset-life-cycle-api": _unref(assetLifeCycleApi),
              "asset-detail-api": _unref(assetDetailApi),
              "asset-search-api": _unref(assetSearchApi),
              "org-list": _unref(options).orgs,
              "company-list": _unref(options).companies,
              "category-list": _unref(fixedCategories)
            }, null, 8, ["export-api", "fixed-asset-count-api", "asset-life-cycle-api", "asset-detail-api", "asset-search-api", "org-list", "company-list", "category-list"])
          ]),
          _: 1
        }, 8, ["name"]),
        _createVNode(_component_el_tab_pane, {
          label: "无形资产查询",
          name: _unref(type_intangible),
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(IntangibleStatisticalInfo, {
              "export-api": _unref(exportApi),
              "asset-search-api": _unref(assetSearchApi),
              "org-list": _unref(options).orgs,
              "company-list": _unref(options).companies
            }, null, 8, ["export-api", "asset-search-api", "org-list", "company-list"])
          ]),
          _: 1
        }, 8, ["name"]),
        _createVNode(_component_el_tab_pane, {
          label: "耗材查询",
          name: _unref(type_consumables),
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(ConsumablesStatisticalInfo, {
              "export-api": _unref(exportApi),
              "asset-search-api": _unref(assetSearchApi),
              "org-list": _unref(options).orgs,
              "company-list": _unref(options).companies,
              "category-list": _unref(consumablesCategories)
            }, null, 8, ["export-api", "asset-search-api", "org-list", "company-list", "category-list"])
          ]),
          _: 1
        }, 8, ["name"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})